jQuery($ => {
  if ($(".m-video-modal-trigger")[0]) {
      $(".m-video-modal-trigger .m-modal-trigger__trigger").mousedown(function () {
        var videoID    = $(this).attr('aria-controls'),
            videoEmbed = $(`#${videoID}`).find('iframe');

        if (videoEmbed) {
          var dataSource = videoEmbed.data('src');

          videoEmbed.attr('src', dataSource);
        }
      });

      $(".m-modal__close").mousedown(function () {

        // console.log( $(this).closest('.m-modal').find('iframe') );
        var $iframe = $(this).closest('.m-modal').find('iframe');

        $iframe.removeAttr('src');
        
      });
  }
});